module.exports = __webpack_public_path__ + "static/media/m_eyeshape_hooded_amber.06fda5a9.png";